export default "__VITE_ASSET__BtDqR9A$__"